import { styled, Colors, Theme } from '@unfold/theme';
import { IDividerProps, TAlign } from './types';

const getMargin = (align: TAlign, space: number): string => {
  if (align === 'center') {
    return `${space}px 0`;
  }

  if (align === 'top') {
    return `0 0 ${space}px`;
  }

  return `${space}px 0 0`;
};

export const StyledDivider = styled.div<IDividerProps>`
  height: ${({ height = 2 }): number => height}px;
  margin: ${({ align = 'center', space = 10 }): string =>
    getMargin(align, space)};
  background-color: ${({
    lineColor = { light: Colors.G600, dark: Colors.DG600 },
    theme,
  }): string =>
    theme.name === Theme.LIGHT ? lineColor.light : lineColor.dark};
`;
